<div class="row" *ngIf="orders && summary">
  <div class="col-12 ">
    <h1>Zamówienia opon</h1>
  </div>
</div>


<div class="d-flex justify-content-center flex-nowrap" *ngIf="orders && summary">

  <div class="text-white mx-2 p-2" *ngIf="orders && orders.length == 0">
    <div class="alert alert-dark mt-3 mb-3"><h3>Brak dostępnych zamówień opon.</h3></div>
  </div>

  <div class="desktop-only text-white mx-2 p-2" *ngIf="orders.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small">
      <thead>
        <tr>
          <th>#</th>
          <th></th>
          <th>Opony</th>
          <th colspan="4">Serwis</th>
          <th></th>
        </tr>

      </thead>
      <tbody>

        <ng-container *ngFor="let order of orders; let i = index;">
          <tr *ngIf="order.Tyre &&  order.Garage" [ngStyle]="summary.CurrentGarageVisit &&  summary.CurrentGarageVisit.TyreFromOrderId == order.OrderId ? {'background-color': '#00bd3f', 'color':'#fff'} : {}">
            <td>
              {{i+1}}
            </td>
            <td><span class="badge {{order.OrderStatusStyle}} margin-r-5">{{order.OrderStatus}}</span></td>
            <td class="text-left">{{ order.Tyre.Name }} x {{order.TyreCount}}</td>
            <td>{{ order.Garage.Name}}</td>
            <td>{{ order.Garage.City}}</td>
            <td>{{ order.Garage.Street}}</td>
            <td>{{ order.Garage.Telephone}}</td>
            <td><i *ngIf="order.IsAldGarageVisitAvailable" class="fa fa-calendar" aria-hidden="true" (click)="onTyreOrderVisit(order)"></i></td>
            <td><i *ngIf="order.IsAldGarageVisitRequestAvailable" class="fa fa-bell" aria-hidden="true" (click)="onDepositeVisitRequest(order)"></i></td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot class="table-legend">
        <tr><td class="firt-legend-row"></td></tr>
        <tr>
          <td><i class="fa fa-calendar" aria-hidden="true"></i></td>
          <td colspan="8">
            {{toolTipGarageVisit}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-bell" aria-hidden="true"></i></td>
          <td colspan="8">
            {{toolTipGarageVisitRequest}}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div class="mobile-only text-white mx-2 p-2" *ngIf="orders.length > 0">
    <table class="table table-striped table-responsive-lg table-hover table-sm small">
      <thead>
        <tr>
          <th>#</th>
          <th>Opony</th>
          <th>Serwis</th>
          <th></th>
        </tr>

      </thead>
      <tbody>
        <ng-container *ngFor="let order of orders; let i = index;">
          <tr *ngIf="order.Tyre &&  order.Garage" [ngStyle]="summary.CurrentGarageVisit &&  summary.CurrentGarageVisit.TyreFromOrderId == order.OrderId ? {'background-color': '#00bd3f', 'color':'#fff'} : {}">
            <td>{{i+1}}</td>
            <td class="text-left">

            <td><span class="badge {{order.OrderStatusStyle}} margin-r-5">{{order.OrderStatus}}</span>
            {{ order.Tyre.Name }} x {{order.TyreCount}}
            </td>
            <td>
              <div>{{ order.Garage.Name}}</div>
              <div>{{ order.Garage.City}}</div>
              <div>{{ order.Garage.Street}}</div>
              <div>{{ order.Garage.Telephone}}</div>
            </td>
            <td>
              <table class="icons">
                <tr>
                  <td>
                    <i *ngIf="order.IsAldGarageVisitAvailable" class="fa fa-calendar fa-2xl" aria-hidden="true" (click)="onTyreOrderVisit(order)"></i>
                  </td>
                </tr>

                <tr>
                  <td class="pt-3">
                    <i *ngIf="order.IsAldGarageVisitRequestAvailable" class="fa fa-bell fa-2xl" aria-hidden="true" (click)="onDepositeVisitRequest(order)"></i>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot class="table-legend">
        <tr><td class="firt-legend-row"></td></tr>
        <tr>
          <td><i class="fa fa-calendar" aria-hidden="true"></i></td>
          <td colspan="5">
            {{toolTipGarageVisit}}
          </td>
        </tr>

        <tr>
          <td><i class="fa fa-bell" aria-hidden="true"></i></td>
          <td colspan="5">
            {{toolTipGarageVisitRequest}}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>


<ng-container *ngIf="!orders || !summary">
  <div class="container z-index-master">
    <div class="row align-items-center">
      <div class="col-md-12">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
